import React, { useEffect, useState } from "react";
import "./ImageGallery.css";

const ImageGallery = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    if (selectedImage) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedImage]);

  return (
    <section className="illustrations-section" id="illustrations">

      <div className="illustrations-container">

        {/* Header */}
        <div className="gallery-header">

          <span className="gallery-eyebrow">
            Visual Exploration
          </span>

          <h2>
            Illustrations
          </h2>

          <p>
            A selection of illustration, concept, and visual design work.
          </p>

        </div>


        {/* Gallery */}
        <div className="gallery-grid">

          {images.map((image, index) => (

            <button
              type="button"
              className="gallery-item"
              key={`${image}-${index}`}
              onClick={() => openModal(image)}
              aria-label={`Open illustration ${index + 1}`}
            >

              <img
                src={image}
                alt={`Illustration ${index + 1}`}
                className="gallery-image"
                loading="lazy"
              />

              <div className="gallery-overlay">

                <span className="gallery-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <span className="gallery-view">
                  View
                </span>

              </div>

            </button>

          ))}

        </div>

      </div>


      {/* Lightbox */}
      {selectedImage && (

        <div
          className="gallery-modal"
          onClick={closeModal}
          role="dialog"
          aria-modal="true"
          aria-label="Illustration preview"
        >

          <button
            type="button"
            className="gallery-modal-close"
            onClick={closeModal}
            aria-label="Close image"
          >
            ×
          </button>


          <div
            className="gallery-modal-inner"
            onClick={(event) => event.stopPropagation()}
          >

            <img
              className="gallery-modal-image"
              src={selectedImage}
              alt="Selected illustration"
            />

          </div>

        </div>

      )}

    </section>
  );
};

export default ImageGallery;